var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoGasConnection = function SvgNoGasConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2451_23713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8827 1.39375H9.17682V0.09375H7.76505V1.39375H6.35329V0.09375H4.94152V1.39375H4.23564C2.67564 1.39375 1.41211 2.55725 1.41211 3.99375V10.4937C1.41211 11.9302 2.67564 13.0938 4.23564 13.0938H9.8827C11.4427 13.0938 12.7062 11.9302 12.7062 10.4937V3.99375C12.7062 2.55725 11.4427 1.39375 9.8827 1.39375ZM7.05917 10.4937C6.08505 10.4937 5.29446 9.77875 5.29446 8.89475C5.29446 8.18625 5.59799 7.99125 7.05917 6.43125C8.50623 7.97825 8.82387 8.18625 8.82387 8.89475C8.82387 9.77875 8.03329 10.4937 7.05917 10.4937ZM9.8827 5.29375H4.23564V3.99375H9.8827V5.29375Z",
    fill: "#currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2451_23713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
export default SvgNoGasConnection;